import { render } from "./LatestBooks.vue?vue&type=template&id=5241dadb"
import script from "./LatestBooks.vue?vue&type=script&lang=js"
export * from "./LatestBooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__